<template>
  <span :class="ns.e('total')" :disabled="disabled">
    {{
      t('lt.pagination.total', {
        total,
      })
    }}
  </span>
</template>

<script lang="ts" setup>
import { useLocale, useNamespace } from '@lit-element/hooks'
import { usePagination } from '../usePagination'
import { paginationTotalProps } from './total'

const { t } = useLocale()
const ns = useNamespace('pagination')
const { disabled } = usePagination()

defineOptions({
  name: 'LtPaginationTotal',
})

defineProps(paginationTotalProps)
</script>
